import { memo } from "react";
import { CellContextWithDragHandle } from "@design-system/ViewTable/ViewTable";
import { DragHandle6DotIcon } from "@icons";
import viewTableStyles from "@design-system/ViewTable/ViewTable.module.scss";
import { CloseTemplateTaskRow } from "../closeTemplateTasksViewConfig";

export const CloseTemplateTaskDragHandleCell = memo(
    ({
        row,
        rowDragHandle,
    }: CellContextWithDragHandle<CloseTemplateTaskRow, string>) => {
        // Group header rows are not draggable
        if (row.original.isGroupRow) {
            return null;
        }

        return (
            <span
                className={viewTableStyles.showOnHover}
                style={{ display: "inline-flex", alignItems: "center" }}
                {...(rowDragHandle?.attributes ?? {})}
                {...(rowDragHandle?.listeners ?? {})}
                onClick={(event) => event.stopPropagation()}
            >
                <DragHandle6DotIcon />
            </span>
        );
    },
);
